module.exports = __webpack_public_path__ + "static/tyne-bridge-8ff84f50d6512f70cda86d1437158412.jpg";